import Vue from 'vue'
import VueRouter from 'vue-router'
import wx from 'weixin-js-sdk'
// 微信分享
import { wxShare } from '@/utils/wxShare'
// store
import store from '@/store/store'

Vue.use(VueRouter)

// 重复点击导航时（连续点击相同路由链接）
// push
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
// replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
	return VueRouterReplace.call(this, to).catch(err => err)
}

const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			path: '/login',
			component: () => import('@/view/Login'),
			meta: {
				title: '登录',
			},
		},
		{
			path: '/',
			component: () => import('@/view/Index'),
			meta: {
				title: '导航',
			},
			children: [
				{
					path: '/index',
					component: () => import('@/view/Nav/Index'),
					meta: {
						title: '御锦健康',
					},
				},
				{
					path: '/hot',
					component: () => import('@/view/Nav/Hot'),
					meta: {
						title: '热销',
					},
				},
				{
					path: '/follow',
					component: () => import('@/view/Nav/Follow'),
					meta: {
						title: '随访·复诊',
					},
				},
				{
					path: '/my',
					component: () => import('@/view/Nav/My'),
					meta: {
						title: '我的',
					},
				},
				// 我的报告列表
				{
					path: '/MyReportList',
					component: () => import('@/view/My/Report/MyReportList'),
					meta: {
						title: '报告',
					},
				},
				// 查找报告列表
				{
					path: '/ReportList',
					component: () => import('@/view/Report/ReportList'),
					meta: {
						title: '报告',
					},
				},
				// 报告详情
				{
					path: '/ReportDeta',
					component: () => import('@/view/Report/ReportDeta'),
					meta: {
						title: '报告详情',
					},
				},
				// 整合式筛查
				{
					path: '/IntegratedGender',
					component: () => import('@/view/Make/Integrated/IntegratedGender'),
					meta: {
						title: '整合式筛查',
					},
				},
				// 列表
				{
					path: '/List',
					component: () => import('@/view/Make/MakeListDeta/List'),
					meta: {
						title: '列表',
					},
				},
				// 添加编辑就诊人信息
				{
					path: '/InfoEdit',
					component: () => import('@/view/My/Info/InfoEdit'),
					meta: {
						title: '添加就诊人信息',
					},
				},
				// 编辑个人信息
				{
					path: '/InfoDeta',
					component: () => import('@/view/My/Info/infoDeta'),
					meta: {
						title: '编辑个人信息',
					},
				},
				// 订单列表
				{
					path: '/OrderList',
					component: () => import('@/view/My/Order/OrderList'),
					meta: {
						title: '订单',
					},
				},
				// 我的预约列表
				{
					path: '/MakeList',
					component: () => import('@/view/My/Make/MyMake'),
					meta: {
						title: '我的预约',
					},
				},
				// 我的预约详情
				{
					path: '/MakeDeta',
					component: () => import('@/view/My/Make/MakeDeta'),
					meta: {
						title: '预约详情',
					},
				},
			],
			redirect: '/index',
		},
		// 首页报告
		{
			path: '/lookupReport',
			component: () => import('@/view/Report/LookupReport'),
			meta: {
				title: '查找报告',
			},
		},
		// 首页预约
		{
			path: '/CarmichaelMake',
			component: () => import('@/view/Make/CarmichaelMake'),
			meta: {
				title: '预约',
			},
		},
		// 预约单品
		{
			path: '/MakeItem',
			component: () => import('@/view/Make/MakeTime/MakeItem'),
			meta: {
				title: '预约单品',
			},
		},
		// 预约套餐
		{
			path: '/MakeSetMeal',
			component: () => import('@/view/Make/MakeTime/MakeSetMeal'),
			meta: {
				title: '预约套餐',
			},
		},
		// 详情
		{
			path: '/Deta',
			component: () => import('@/view/Make/MakeListDeta/Deta'),
			meta: {
				title: '详情',
			},
		},
		{
			path: '/InfoList',
			component: () => import('@/view/My/Info/InfoList'),
			meta: {
				title: '就诊人信息',
			},
		},
		// 订单详情
		{
			path: '/OrderDeta',
			component: () => import('@/view/My/Order/OrderDeta'),
			meta: {
				title: '订单详情',
			},
		},
		// 肠道准备
		{
			path: '/StomachPlan',
			component: () => import('@/view/My/Order/StomachPlan'),
			meta: {
				title: '胃肠道准备',
			},
		},
		// 关于我们
		{
			path: '/About',
			component: () => import('@/view/My/About'),
			meta: {
				title: '关于我们',
			},
		},
		// 预约随访
		{
			path: '/FollowDeta',
			component: () => import('@/view/Follow/FollowDeta'),
			meta: {
				title: '预约复诊',
			},
		},
		// 随访详情
		{
			path: '/FollowResult',
			component: () => import('@/view/Follow/FollowResult'),
			meta: {
				title: '复诊详情',
			},
		},
		// 上传我的医疗数据
		{
			path: '/FollowUpload',
			component: () => import('@/view/Follow/FollowUpload'),
			meta: {
				title: '上传我的医疗资料',
			},
		},
		// 上传历史详情
		{
			path: '/HistoryDeta',
			component: () => import('@/view/Follow/HistoryDeta'),
			meta: {
				title: '上传历史详情',
			},
		},
		// 试剂盒
		{
			path: '/TestKitSpread',
			name: 'TestKitSpread',
			component: () => import('../view/TestKit/TestKitSpread'),
			meta: {
				title: '领取登记',
			},
		},
		{
			path: '/TestKitCommitment',
			name: 'TestKitCommitment',
			component: () => import('../view/TestKit/TestKitCommitment'),
			meta: {
				title: '知情同意书',
			},
		},
		{
			path: '/TestKitInfo',
			name: 'TestKitInfo',
			component: () => import('../view/TestKit/TestKitInfo'),
		},
		{
			path: '/TestKitInfoResult',
			name: 'TestKitInfoResult',
			component: () => import('../view/TestKit/TestKitInfoResult'),
		},
		{
			path: '/TestKitSee',
			name: 'TestKitSee',
			component: () => import('../view/TestKit/TestKitSee'),
			meta: {
				title: '结果查询',
			},
		},
		{
			path: '/TestKitSeeResult',
			name: 'TestKitSeeResult',
			component: () => import('../view/TestKit/TestKitSeeResult'),
			meta: {
				title: '预测肠道风险结果',
			},
		},

		{
			path: '/OperateSee',
			name: 'OperateSee',
			component: () => import('../view/OperateSee/OperateSee'),
			meta: {
				title: '运营结果查询',
			},
		},

		// 无网络
		{
			path: '/NoNetwork',
			component: () => import('@/view/State/NoNetwork'),
			meta: {
				title: '无网络',
			},
		},
		// 注意事项
		{
			path: '/beCareful',
			component: () => import('@/view/State/beCareful'),
			meta: {
				title: '注意事项',
			},
		},
		// 随访介绍页面
		{
			path: '/FollowIntroduction',
			component: () => import('@/view/Swiper/FollowIntroduction'),
			meta: {
				title: '随访介绍',
			},
		},
		// 活动页
		{
			path: '/Activity',
			component: () => import('@/view/Swiper/Activity'),
			meta: {
				title: '活动页',
			},
		},
		// 404
		{
			path: '*',
			component: () => import('@/view/State/Four'),
			meta: {
				title: '404',
			},
		},
	],
})

router.beforeEach((to, form, next) => {
	if (
		to.path == '/Deta' ||
		to.path == '/index' ||
		to.path == '/hot' ||
		to.path == '/TestKitSpread'
	) {
		if (to.path == '/Deta') {
			var data = null
			if (to.query.fromUserId) {
				// to.query.fromUserId= store.state.UserId;
				data =
					to.path +
					'?id=' +
					to.query.id +
					'&fromUserId=' +
					to.query.fromUserId +
					'&thumbnail=' +
					to.query.thumbnail +
					'&productName=' +
					to.query.productName
			} else {
				data = to.fullPath + '&fromUserId=' + store.state.UserId
			}

			setTimeout(() => {
				wxShare(data, '御锦健康', to.query.productName, to.query.thumbnail)
			}, 1000)
		} else {
			if (to.path == '/TestKitSpread') {
				setTimeout(() => {
					wxShare(
						to.fullPath,
						'大肠癌筛查优化项目',
						'领取登记、结果查询',
						'https://yujin-hm-prod.oss-cn-beijing.aliyuncs.com/common/reagent-invite.png'
					)
				}, 1000)
			} else {
				wxShare(to.fullPath, '御锦健康', '御锦健康与您在一起')
			}
		}
	} else {
		wx.ready(function() {
			var u = navigator.userAgent
			var ua = u.toLowerCase()
			if (/iphone|ipad|ipod/.test(ua)) {
				// iOS 系统 ->  跳AppStore下载地址
				//alert("iOS");
				wx.hideMenuItems({
					// 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
					menuList: [
						'menuItem:share:appMessage',
						'menuItem:share:timeline',
						'menuItem:share:qq',
					],
				})
				// wx.hideAllNonBaseMenuItem();
			} else if (/android/.test(ua)) {
				// 安卓系统 -> 跳安卓端下载地址
				setTimeout(() => {
					wx.hideMenuItems({
						// 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
						menuList: [
							'menuItem:share:appMessage',
							'menuItem:share:timeline',
							'menuItem:share:qq',
						],
					})
					// wx.hideAllNonBaseMenuItem();
				}, 1000)
			}
		})
	}
	document.title = to.meta.title
	next()
})

export default router
